import { clearEventPageSelections, getEventPageSelections } from 'services/storage';
import { IEvent, TicketWithQuantitySelected } from 'store/eventPage/types';

export interface EventSelections {
  custom_amount: number;
  event_tickets: TicketWithQuantitySelected[];
}

export const getEventSelectionsObj = () => {
  const eventSelections = getEventPageSelections();
  if (!eventSelections) {
    return;
  }
  return JSON.parse(eventSelections);
};

export const getTicketCount = (tickets: TicketWithQuantitySelected[]) => {
  return tickets.reduce((acc, ticket) => acc + ticket.quantity_selected, 0);
};

export const getTicketsWithSelections = (tickets: TicketWithQuantitySelected[]) => {
  return tickets.filter(ticket => ticket.quantity_selected > 0);
};

export const getTicketPriceTotal = (ticketSelections: TicketWithQuantitySelected[]) =>
  ticketSelections.reduce((total, ticket) => total + ticket.quantity_selected * ticket.price, 0);

export const getTicketSelectionsFromEventData = (eventData: IEvent) =>
  eventData.tickets.map(ticket => ({
    ...ticket,
    quantity_selected: 0,
    price: ticket.price / 100,
  }));

export const getCustomAmountFromTicketSelections = (
  donationAmount: number,
  ticketSelections: TicketWithQuantitySelected[]
) => {
  const ticketPriceTotal = getTicketPriceTotal(ticketSelections);
  return Math.max(0, donationAmount - ticketPriceTotal);
};

export const clearEventFromStorageIfNeeded = (eventData: IEvent) => {
  const eventSelections = getEventSelectionsObj();
  if (eventSelections && eventSelections.event_id !== eventData.event_id) {
    clearEventPageSelections();
  }
};

export const formatTicketSummary = (
  ticketSelections: TicketWithQuantitySelected[],
  donationAmount: number
) => {
  const tickets = getTicketsWithSelections(ticketSelections);
  const hasCustomAmount = getCustomAmountFromTicketSelections(donationAmount, ticketSelections) > 0;
  let summary = tickets
    .map(
      ticket =>
        `${ticket.quantity_selected} ${ticket.name} ticket${
          ticket.quantity_selected == 1 ? '' : 's'
        }`
    )
    .join(tickets.length === 2 && !hasCustomAmount ? ' & ' : ', ');
  if (tickets.length === 0) {
    return '';
  }
  if (tickets.length > 1 && hasCustomAmount) {
    summary += ',';
  }
  if (hasCustomAmount) {
    summary += ' & additional donation';
  }
  return summary;
};
